import { render, staticRenderFns } from "./SchoolNotFoundError.vue?vue&type=template&id=5a529b22&scoped=true&lang=pug&"
import script from "./SchoolNotFoundError.vue?vue&type=script&lang=ts&"
export * from "./SchoolNotFoundError.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolNotFoundError.vue?vue&type=style&index=0&id=5a529b22&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a529b22",
  null
  
)

export default component.exports